import { Header, Illustration, Confetti } from 'hello-design-system'
import {
    LevelCompletionScreenContent,
    LevelCompletionVariant,
    LEVEL_COMPLETION_COUNTDOWN_SECONDS
} from 'utils/constants'
import type { LevelCompletionVariantValue } from 'utils/constants'
import { ContentContainer } from '../styles'
import {
    ScreenRoot,
    PageRoot,
    HeroSection,
    IllustrationBackdrop,
    Title,
    Subtitle
} from './styles'
import { AutoRedirectSection } from './AutoRedirectSection'
import { ContinueStudyingCta } from './ContinueStudyingCta'

export interface LevelCompletionScreenProps {
    unitNumber?: number
    variant: Exclude<LevelCompletionVariantValue, typeof LevelCompletionVariant.OFF>
    onContinue: () => void
}

export const COUNTDOWN_TICK_MS = 50
export const COUNTDOWN_DURATION_MS = LEVEL_COMPLETION_COUNTDOWN_SECONDS * 1000

const LevelCompletionScreen: React.FC<LevelCompletionScreenProps> = ({
    unitNumber,
    variant,
    onContinue
}) => (
    <ScreenRoot data-testid='level-completion-screen'>
        <Confetti recycle={false} />
        <Header />
        <ContentContainer>
            <PageRoot>
                <HeroSection>
                    <IllustrationBackdrop data-testid='finish-flag-backdrop'>
                        <Illustration
                            name='finish_flag'
                            size='large'
                        />
                    </IllustrationBackdrop>
                    <Title variant='h3'>
                        {LevelCompletionScreenContent.title}
                    </Title>
                    {unitNumber !== undefined && (
                        <Subtitle variant='body1'>
                            {LevelCompletionScreenContent.subtitle(unitNumber)}
                        </Subtitle>
                    )}
                </HeroSection>
                {variant === LevelCompletionVariant.AUTO_REDIRECT
                    ? (
                        <AutoRedirectSection onContinue={onContinue} />
                    )
                    : (
                        <ContinueStudyingCta onContinue={onContinue} />
                    )}
            </PageRoot>
        </ContentContainer>
    </ScreenRoot>
)

export { LevelCompletionScreen }
